import { getUrlParts } from '@Utils/get-url-parts';
import { isUrl } from '@Utils/is-url';
import { supportsPassiveOption } from '@Utils/supports-passive-option';
import { underscore_debounce } from '@Utils/underscore-debounce';
import { underscore_throttle } from '@Utils/underscore-throttle';

window.ci_Utils = {
    getUrlParts,
    isUrl,
    supportsPassiveOption,
    underscore_debounce,
    underscore_throttle
};